import React, { useEffect, useRef, useState } from 'react';
import FlexComponent from '../../FlexComponent';
import { Button } from 'primereact/button';
import { Avatar } from 'primereact/avatar';
import '../apps.css'
import { useNavigate } from 'react-router-dom';
import { Badge } from 'primereact/badge';
import { OverlayPanel } from 'primereact/overlaypanel';
import { useSelector } from 'react-redux';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import axios from '../../../utils/axios';
import { archiveSubmission, autoDocFollowupToggle, deleteSubmission, downloadXmlFile } from '../../../utils/urls';
import { ConfirmPopup, confirmPopup } from 'primereact/confirmpopup';
import AppScoreBars from './AppScoreBars';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCoffee, faUser, faStar, faCoins, faCreditCard, faPiggyBank } from '@fortawesome/free-solid-svg-icons';
import { faClock } from '@fortawesome/free-regular-svg-icons';
import { WORKING_ON_CLASS, WorkingOnChip } from '../workingOn/WorkingOn';
import { useAppWorkingOn } from '../workingOn/useAppWorkingOn';

const AppItem = ({ app, userId, toast, setTotal, setBoardSections, isSelectMode = false, isSelected = false, onCardSelect }) => {
    const navigate = useNavigate()
    const dotsOp = useRef(null);
    const otherCustomFields = getValuesByNames(app?.customFields, ["Loan Amount", "Purchase Price", "Loan Amount Status", "Est. Taxes"])
    // console.log("otherCustomFields", otherCustomFields)
    const [autoDocToogle, setAutoDocToggle] = useState(app?.is_doc_followup)
    const { isWorking } = useAppWorkingOn(app)

    // const otherCustomFieldIds = {
    //     "Loan Amount" : 22,
    //     "Purchase Price" : 24,
    //     "App Score" : 36
    // }

    const isSuperuser = useSelector((state) => state.user.isSuperuser)
    const designation = useSelector((state) => state.user.designation)

    const redirectProfilePage = (contact_id, form_id) => {
        navigate(`/app/${contact_id}/${form_id}`)
    }

    let AppScoreT = app?.customFields?.find(item => item.name === "App Score")?.value
    // console.log(AppScoreT)

    function changeIncomeColor(applicantIncome) {
        if (!applicantIncome) return '';
        let str = applicantIncome.toLowerCase().replace(/[$,]/g, '').trim();
        let income = 0;

        if (str.endsWith('k')) {
            income = parseFloat(str) * 1000;
        } else {
            income = parseFloat(str);
        }
        if (isNaN(income)) return '';
        if (income >= 80000) {
            return '#00C896';
        } else if (income >= 65000) {
            return 'rgb(255 180 0 / 58%)';
        } else {
            return 'rgb(255 78 78 / 58%)';
        }
    }


    function changeCreditColor(applicantCredit) {
        const credit = parseInt(applicantCredit);
        // console.log(credit)
        if (isNaN(credit)) return '';
        if (credit >= 620) {
            return '#00C896';
        } else if (credit < 620 && credit >= 500) {
            return 'rgb(255 180 0 / 58%)';
        } else {
            return 'rgb(255 78 78 / 58%)'
        }
    }

    function changeAvailableColor(cashAvailable) {
        if (!cashAvailable) return '';

        let str = cashAvailable.toLowerCase().replace(/[$,]/g, '').trim();
        let amount = 0;

        if (str.endsWith('k')) {
            amount = parseFloat(str) * 1000;
        } else {
            amount = parseFloat(str);
        }

        if (isNaN(amount)) return '';

        if (amount >= 45000) {
            return '#00C896';
        } else if (amount >= 20000) {
            return 'rgb(255 180 0 / 58%)';
        } else {
            return 'rgb(255 78 78 / 58%)';
        }
    }


    function getInitials(string) {
        let words = string?.split(' ');
        let initials = words?.map(word => word.charAt(0).toUpperCase());
        return initials?.join('');
    }

    function formatDate(inputDate) {
        const dateParts = inputDate.split(' ')[0].split('-');
        const year = dateParts[0];
        const month = dateParts[1];
        const day = dateParts[2];

        const date = new Date(`${year}-${month}-${day}`);

        const monthNames = [
            'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
            'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'
        ];
        const formattedDate = `${parseInt(day)} ${monthNames[date.getMonth()]}, ${year}`;
        return formattedDate;
    }

    const handleArchiveCard = (event) => {
        // setLoading(true)
        confirmPopup({
            message: 'Are you sure you want to Archive this card?',
            target: event.currentTarget,
            group: 'headless',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                setBoardSections(prevSections => {
                    const updatedSections = { ...prevSections };
                    for (const sectionId in updatedSections) {
                        updatedSections[sectionId] = updatedSections[sectionId].filter((item) => item.form_id !== app.form_id)
                    }
                    return updatedSections;
                });
                const Url = `${archiveSubmission}${app.form_id}`
                axios.post(Url, {
                    headers: { 'Content-Type': 'application/json' },
                })
                    .then((response) => {
                        if (response.status === 200) {
                            // setLoading(false)
                            toast.current.show({ severity: 'success', summary: 'SuccessFully Archived', detail: '', life: 3000 });
                            setTotal((prev) => prev - 1)
                        }
                    })
                    .catch((error) => {
                        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
                        // handleClose()
                        // setLoading(false)
                    })

            },
            reject: () => {
                console.log("closed")
            }
        });
    };

    const handleDeleteCard = (event) => {
        // setLoading(true)
        confirmPopup({
            message: 'Are you sure you want to Delete this card?',
            target: event.currentTarget,
            group: 'headless',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                setBoardSections(prevSections => {
                    const updatedSections = { ...prevSections };
                    for (const sectionId in updatedSections) {
                        updatedSections[sectionId] = updatedSections[sectionId].filter((item) => item.form_id !== app.form_id)
                    }
                    return updatedSections;
                });
                const Url = `${deleteSubmission}${app.form_id}`
                axios.post(Url, {
                    headers: { 'Content-Type': 'application/json' },
                })
                    .then((response) => {
                        if (response.status === 200) {
                            // setLoading(false)
                            toast.current.show({ severity: 'success', summary: 'SuccessFully Deleted', detail: '', life: 3000 });
                        }
                    })
                    .catch((error) => {
                        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
                        // setLoading(false)
                    })

            },
            reject: () => {
                console.log("closed")
            }
        });
    };

    const toggleAutoDoc = async () => {
        try {
            const data = {
                is_doc_followup: !app?.is_doc_followup,
            }
            setAutoDocToggle(!autoDocToogle)
            // console.log(data)
            const response = await axios.post(`${autoDocFollowupToggle}${app?.form_id}/`, data);
            if (response.status === 200) {
                // console.log('Order updated successfully');
                toast.current.show({ severity: 'success', summary: '', detail: 'Success', life: 3000 });

            } else {
                console.error('Failed to update order');
            }
        } catch (error) {
            console.error('Error updating order:', error);
        }
    }

    function convertDate(utcDateString) {
        if (!utcDateString) return "";
        const utcDate = new Date(utcDateString);

        const dateOptions = {
            month: 'short', // Use 'long' for full month name (e.g., "September") or 'short' for abbreviated (e.g., "Sep")
            day: '2-digit', // Day with leading zero (e.g., "13")
            year: 'numeric',
        };

        const formattedDate = utcDate.toLocaleDateString('en-US', dateOptions); // Use 'en-US' for month-first format

        const formattedLocalDateTime = `${formattedDate}`;

        return formattedLocalDateTime;
    }

    function isDateDue(utcDateString) {
        const utcDate = new Date(utcDateString);
        const now = new Date();
        return utcDate < now;
    }

    function getDueDateColor(dueDateString) {
        try {
            const dueDate = new Date(dueDateString);
            if (isNaN(dueDate)) {
                return ""; // Invalid date
            }

            const now = new Date();
            const timeDiff = dueDate - now;
            const twelveHours = 12 * 60 * 60 * 1000;

            const sevenDays = 7 * 24 * 60 * 60 * 1000;

            if (timeDiff <= 0 && timeDiff > -sevenDays) {
                return "#FF0000";
            } else if (timeDiff <= -sevenDays) {
                return "rgba(100, 160, 200, 0.22)";
            } else if (timeDiff <= twelveHours) {
                return "#fbbc05";
            } else {
                return "";
            }
        } catch (e) {
            return ""; 
        }
    }

    function getValuesByNames(customFields, names) {
        return Object.fromEntries(
            names.map(name => [
                name,
                customFields.find(f => f.name === name)?.value ?? null
            ])
        );
    }

    function formatNumber(number) {
        if (number == null || number === '') {
            return '';
        }
        const cleanStr = String(number).replace(/,/g, '');
        const num = parseFloat(cleanStr);

        if (isNaN(num)) {
            return String(number); // or throw new Error('Invalid number')
        }
        if (num >= 1_000_000_000) {
            return (num / 1_000_000_000).toFixed(1) + 'B';
        }
        if (num >= 1_000_000) {
            return (num / 1_000_000).toFixed(1) + 'M';
        }
        if (num >= 1_000) {
            return (num / 1_000).toFixed(1) + 'k';
        }
        return num.toLocaleString('en-US');
    }

    const DownloadLoanXMLButton = async () => {
        try {
            const response = await axios.get(`${downloadXmlFile}${app?.form_id}`, {
                responseType: 'blob',
            });

            const blob = new Blob([response.data], { type: 'application/xml' });
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            const name = app?.full_name?.replace(/ /g, '_') || 'loan_application';
            link.download = `${name}_LOAN_APPLICATION_XML.xml`;
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (error) {
            console.error('Error downloading XML:', error);
            toast.current.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Failed to download XML file',
                life: 3000,
            });
        }
    };

    const formatLastCommunication = (lastCommunication) => {
        if (!lastCommunication) return "Never";

        const date = new Date(lastCommunication);
        if (isNaN(date)) return "Invalid date";

        const now = new Date();
        const diffMs = now - date;
        const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

        if (diffDays > 1) {
            return `${diffDays} d`;
        }

        const diffMinutes = Math.floor(diffMs / (1000 * 60));
        const hours = Math.floor(diffMinutes / 60);
        const minutes = diffMinutes % 60;

        if (hours >= 1) {
            // return `${hours} h${hours > 1 ? "s" : ""}${minutes > 0 ? ` ${minutes} m${minutes > 1 ? "s" : ""}` : ""} `;
            return `${hours} h${hours > 1 ? "" : ""}${minutes > 0 ? ` ${minutes} m${minutes > 1 ? "" : ""}` : ""} `;
        } else if (minutes >= 1) {
            return `${minutes} m${minutes > 1 ? "" : ""}`;
        } else {
            return "Just now";
        }
    };

    const getCommunicationColor = (lastCommunication) => {
        if (!lastCommunication) return "lightgrey";

        const date = new Date(lastCommunication);
        if (isNaN(date)) return "lightgrey";

        const now = new Date();
        const diffMs = now - date;
        const diffHours = diffMs / (1000 * 60 * 60);

        if (diffHours >= 72) {
            return "red";
        } else if (diffHours >= 48) {
            return "yellow";
        } else if (diffHours >= 24) {
            return "lightgrey";
        } else {
            return "lightgrey";
        }
    };

    function getContrastColor(hex) {
        // Remove the # if present
        hex = hex.replace(/^#/, "");

        // Convert 3-digit hex to 6-digit
        if (hex.length === 3) {
            hex = hex.split("").map(c => c + c).join("");
        }

        // Convert to RGB
        const r = parseInt(hex.substr(0, 2), 16);
        const g = parseInt(hex.substr(2, 2), 16);
        const b = parseInt(hex.substr(4, 2), 16);

        // Calculate luminance (perceived brightness)
        const luminance = (0.299 * r + 0.587 * g + 0.114 * b);

        // If luminance is high, return black; else white
        return luminance > 186 ? "black" : "white";
    }

    return (
        <div className={`appItem ${isWorking ? WORKING_ON_CLASS : ''}`} style={{ boxShadow: "-1px -2px 0px #ffffff40", padding: '10px', cursor: 'pointer', background: isSelected ? 'rgba(37, 99, 235, 0.25)' : 'rgba(255, 255, 255, 0.06)', position: 'relative', outline: isSelected ? '2px solid #3b82f6' : 'none', borderRadius: '4px' }}
            onClick={isSelectMode ? (e) => { e.stopPropagation(); onCardSelect && onCardSelect(app); } : undefined}
        >
            {isSelectMode && (
                <div style={{ position: 'absolute', top: '8px', right: '8px', zIndex: 10 }}>
                    <input type="checkbox" checked={isSelected} readOnly style={{ width: '16px', height: '16px', accentColor: '#3b82f6', cursor: 'pointer' }} />
                </div>
            )}
            <FlexComponent flexDirection='column' alignItems='start'>
                <FlexComponent>
                    {/* <div style={{ height: "5px", width: "5px", borderRadius: "5px", background: getCommunicationColor(app.last_communication) }} ></div> */}
                    <div></div>
                    {/* <div style={{ color: getCommunicationColor(app.last_communication), fontSize: "10px" }} >{formatLastCommunication(app.last_communication)}</div> */}

                </FlexComponent>
                <FlexComponent justifyContent="end" gap=".3rem" >
                    <FlexComponent justifyContent="start" alignItems="start" gap="3px" flexWrap="wrap" >
                        {app.labels.map((list, index) => (
                            <FlexComponent justifyContent="start" key={index} style={{ width: "auto", minHeight: "8px" }} ><span style={{ background: `#${list.color}`, color: getContrastColor(list.color), borderRadius: "10px", padding: "0 .5rem ", fontSize: "10px" }} >{list.name}</span> </FlexComponent>
                        ))}
                    </FlexComponent>
                    {/* <div style={{ width:"5%"}}>
                    <i style={{color:"white"}} className='pi pi-ellipsis-v'></i>
                    </div> */}
                </FlexComponent>
                <FlexComponent style={{ marginTop: app.labels.length > 0 ? ".3rem" : "" }} alignItems='start'>
                    <div style={{ width: "70%" }}>
                        {/* <p style={{ fontSize: '14px', color: '#B1B1B1' }} >{app?.location_name}</p> */}
                        <p style={{ fontSize: '18px' }}>{app?.full_name}</p>
                    </div>
                    <FlexComponent style={{ width: "30%" }} justifyContent="end" >
                        <div style={{ width: "65%" }} >
                            <div style={{ color: getCommunicationColor(app.last_communication), fontSize: "10px" }} >{formatLastCommunication(app.last_communication)}</div>
                            <p style={{ fontSize: '10px', minWidth: "70px" }}>{formatDate(app?.created_date)}</p>
                            {/* <p style={{ fontSize: '10px' }}>{app?.language}</p> */}
                        </div>
                        {/* {isSuperuser && <div onClick={(e) => {
                            e.stopPropagation()
                            dotsOp.current.toggle(e)
                        }}>
                            <i style={{ color: "white" }}
                                className='pi pi-ellipsis-v'></i>
                            <OverlayPanel onClick={(e) => {
                                e.stopPropagation()
                            }} ref={dotsOp} style={{ background: '#1A2B53' }} >
                                <FlexComponent gap="1rem" >
                                    <ConfirmPopup />
                                    <Button onClick={(e) => {
                                        e.stopPropagation()
                                        handleArchiveCard(e)
                                    }} >Archive</Button>
                                    <Button onClick={(e) => {
                                        e.stopPropagation()
                                        handleDeleteCard(e)
                                    }}>Delete</Button>
                                </FlexComponent>
                            </OverlayPanel>
                        </div>} */}
                    </FlexComponent>
                </FlexComponent>
                {(otherCustomFields && otherCustomFields["Loan Amount"] && otherCustomFields["Purchase Price"]) ? <FlexComponent justifyContent='start' gap='.8rem' style={{ marginTop: ".2rem" }}>
                    <div>
                        <p style={{ textAlign: "center", fontSize: '18px' }}>{formatNumber(otherCustomFields["Loan Amount"])}</p>
                        <p>Loan Amount</p>
                    </div>
                    <div>
                        <p style={{ textAlign: "center", fontSize: app?.credit.length > 5 ? '12px' : '18px' }}>{formatNumber(otherCustomFields["Purchase Price"])}</p>
                        <p>Purchase Price</p>
                    </div>

                    {otherCustomFields["Loan Amount Status"] === "Preapproved" && otherCustomFields["Est. Taxes"] && <div>
                        <p style={{ textAlign: "center", fontSize: '18px' }}>{formatNumber(otherCustomFields["Est. Taxes"])}</p>
                        <p style={{ textAlign: "center" }} >Est. Taxes</p>
                    </div>}
                    {/* <div style={{color:"white", width:"50px", fontSize: "12px", padding:"0 .5rem", borderRadius:"5px", background : isDateDue(app?.due_date) ? "red" : "green"}} >{convertDate(app?.due_date)}</div> */}


                </FlexComponent> : <div className='CardNumbersSection' >
                    {(app?.income !== "$0" || parseInt(app?.credit) || app?.savings !== "$0") && <FlexComponent justifyContent='start' gap='.8rem' style={{ marginTop: ".2rem" }}>
                        <div title="Income">
                            <FlexComponent style={{ fontWeight: "bold", textAlign: "center", color: app?.income === "$0" ? "grey" : changeIncomeColor(app?.income), fontSize: '16px', gap: ".25rem" }}>
                                <FontAwesomeIcon icon={faCoins} />{app?.income === "$0" ? "N/A" : app?.income}
                            </FlexComponent>
                            {/* <p>Income</p> */}
                        </div>
                        <div title="Credit">
                            <FlexComponent style={{ fontWeight: "bold", textAlign: "center", color: parseInt(app?.credit) ? changeCreditColor(app?.credit) : "grey", fontSize: app?.credit.length > 5 ? '12px' : '16px', gap: ".25rem" }}>
                                <FontAwesomeIcon icon={faCreditCard} />{parseInt(app?.credit) || "N/A"}
                            </FlexComponent>
                            {/* <p>Credit</p> */}
                        </div>
                        <div title="Available">
                            <FlexComponent style={{ fontWeight: "bold", textAlign: "center", color: app?.savings === "$0" ? "grey" : changeAvailableColor(app?.savings), fontSize: '16px', gap: ".25rem" }}>
                                <FontAwesomeIcon icon={faPiggyBank} />{app?.savings === "$0" ? "N/A" : app?.savings}
                            </FlexComponent>
                            {/* <p>Available</p> */}
                        </div>

                        {/* <div style={{color:"white", width:"50px", fontSize: "12px", padding:"0 .5rem", borderRadius:"5px", background : isDateDue(app?.due_date) ? "red" : "green"}} >{convertDate(app?.due_date)}</div> */}

                    </FlexComponent>}
                </div>
                }
                <FlexComponent style={{ marginTop: "10px" }} gap="1rem" >
                    {/* {app?.watchers?.includes(userId) && <i style={{color:"white"}} className='pi pi-eye'></i>} */}
                    {app?.due_date && <div style={{ fontWeight: "600", color: getDueDateColor(app?.due_date) === "#fbbc05" ? "black" : getDueDateColor(app?.due_date) === "rgba(100, 160, 200, 0.22)" ? "rgba(140, 190, 220, 0.95)" : "white", fontSize: "14px", padding: ".5rem", borderRadius: "5px", background: getDueDateColor(app?.due_date) }} ><FontAwesomeIcon icon={faClock} /> {convertDate(app?.due_date)}</div>}

                    <FlexComponent style={{ width: app?.due_date ? "auto" : "100%" }} gap="0.1rem" justifyContent="end" alignItems="start">
                        {app?.images?.map((user, index) => (
                            <div key={index}>
                                {index < 5 &&
                                    <div style={{ position: "relative" }} >
                                        <Avatar image={user?.image} style={{ width: '30px', height: '30px', }} className="p-overlay-badge" size="small" shape='circle'
                                            label={getInitials(user?.name)}
                                        >
                                            {/* <Badge value="^" /> */}
                                            {(user?.roles.includes("application_by") && user?.roles.includes("contact_owner")) ? <div style={{ marginTop: "20px", transform: 'Scale(0.7)' }} >
                                                <i className="pi pi-angle-double-up" style={{ position: "absolute", marginLeft: "-12px", color: "white", background: "blue", borderRadius: "20px" }} ></i>
                                            </div> :
                                                (user?.roles.includes("application_by")) ? <div style={{ marginTop: "20px", transform: 'Scale(0.7)' }} >
                                                    <i className="pi pi-angle-up" style={{ position: "absolute", marginLeft: "-12px", color: "white", background: "#2FC623", borderRadius: "20px" }} ></i>
                                                </div> : (user?.roles.includes("contact_owner")) ? <div style={{ marginTop: "20px", transform: 'Scale(0.7)' }} >
                                                    <i className="pi pi-angle-up" style={{ position: "absolute", marginLeft: "-12px", color: "white", background: "red", borderRadius: "20px" }} ></i>
                                                </div> : ''}
                                        </Avatar>
                                    </div>
                                }
                            </div>
                        ))}
                        {app?.images?.length > 5 && <Avatar style={{ width: '30px', height: '30px' }} size="small" shape='circle' label={`${app?.length - 4}+`} />}
                    </FlexComponent>

                </FlexComponent >
                {app?.contract_due_date && <div style={{ color: "white", fontSize: "12px", marginTop: ".5rem", padding: "0 .5rem", borderRadius: "5px", background: isDateDue(app?.contract_due_date) ? "red" : "" }} >Contract - {convertDate(app?.contract_due_date)}</div>}
                <FlexComponent justifyContent="end" >
                    {/* <div>
                        <Button tooltip="Contact view" onMouseDown={() => window.open(`https://phone.bcrumbs.com/v2/location/${app?.location_id}/contacts/detail/${app?.ghl_contact_id}`, '_blank')} style={{ background: 'transparent', color: 'white', padding: '0.3rem' }} ><i className="pi pi-external-link"></i></Button>
                        <Button tooltip="Profile View" style={{ background: 'transparent', color: 'white', padding: '0.3rem' }} onMouseDown={() => window.open(`/app/${app?.ghl_contact_id}/${app?.form_id}`, '_blank')}
                        ><i className="pi pi-book"></i></Button>
                        {(isSuperuser || designation === "Loan Officer Assistant" || userId === 16) && <Button
                            tooltip="Download XML"
                            style={{ background: 'transparent', color: 'white', padding: '0.3rem' }}
                            onClick={(e) => {
                                e.stopPropagation();
                                DownloadLoanXMLButton();
                            }}
                        >
                            <i className="pi pi-download"></i>
                        </Button>}
                        <Button tooltip={autoDocToogle ? "Remove Auto Doc Followup" : "Add Auto Doc Followup"} style={{ background: 'transparent', color: 'white', padding: '0.3rem' }} onClick={(e) => {
                            e.stopPropagation();
                            toggleAutoDoc();
                        }} ><i className={autoDocToogle ? "pi pi-check-square" : "pi pi-file"}></i></Button>

                    </div> */}
                    <div >

                    </div>
                </FlexComponent>
                {/* <div> */}
                {AppScoreT && <AppScoreBars score={AppScoreT} />}
                <WorkingOnChip app={app} />
                {/* </div> */}
            </FlexComponent>

        </div>
    );
};

export default AppItem;
